import React from 'react';
import { StyledNewsArticle } from './StyledNewsArticle';

const NewsArticle = ({ data }) => {
  // calendar
  // https://codepen.io/ncer/pen/NxGOoj

  return (
    <React.Fragment>
      {
       
          <StyledNewsArticle>
            <div className="article-header">
              <p className="preset-13 category">{ data.category }</p>
              <h4 className="md--title news-title">{ data.title} </h4>
              <div className="details-wrapper">
                {
                  data.date &&
                  <div className="detail-col">
                    <img src="/calendar-date.svg" />
                    <p className="preset-12">{data.date}</p>
                  </div>
                }
                {
                  data.is_event &&
                  data.place !== "" && 
                  <div className="detail-col">
                    <img src="/location.svg" />
                    <p className="preset-12">{data.place}</p>
                  </div>
                }
              </div>
            </div>
            <img className="cover-image" src={data.img_hero} />
            <div className="article-wrap">
              <article className="text-wrap" dangerouslySetInnerHTML={{ __html: data.text }}>
              </article>
              <aside className="aside-article">
                
                  {
                    data.is_event &&
                    data.speakers !== undefined &&
                    data.speakers.length > 0 &&
                    <div className="aside-cell speakers-cell">
                      <p className="preset-11">Speakers</p>
                      {
                        data.speakers.map((key, i) => {
                          return <p key={i} className="preset-12 speaker">{key}</p>;
                        })
                      }
                    </div>
                  }
                  
                {
                  data.is_event &&
                  data.time !== "" &&
                  <div className="aside-cell date-cell">
                    <img src="/calendar-date.svg" />
                    <p className="preset-12">{data.time}</p>
                  </div>
                }
                {
                  data.is_event &&
                  data.place !== "" &&
                  <div className="aside-cell place-cell">
                    <img src="/calendar-date.svg" />
                    <p className="preset-12">{data.place}</p>
                    {
                      data.direction !== '' &&
                      <a href={data.direction} target="_blank">Get directions</a>
                    }
                  </div>
                }
              </aside>
            </div>
            
          </StyledNewsArticle>
          
      }
    </React.Fragment>
  );
};


export default NewsArticle;
